import React, { Fragment, useEffect, useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import { InformationIcon, FileIcon, InformationCircleIcon } from 'icons/';
import './informationButton.scss';
import { IdeaIcon } from '../icons/IdeaIcon';

type InformationButtonProps = {
    containerClassName?: string,
    tooltip?: string,
    tooltipId?: string,
    dataFor?: string,
    isDisabled: boolean,
    width?: number,
    height?: number,
    tabIndex?: number,
    icon: 'info' | 'circle' | 'pdf' | 'idea',
    onInformationClicked(): void,
    onMouseOver?(targetElementRef: React.MutableRefObject<HTMLButtonElement | null>): void,
    onMouseOut?(): void
}

export function InformationButton(props: InformationButtonProps) {
    if (props.isDisabled === true) {
        return null;
    }

    const containerClassName: string = props.containerClassName || 'information__focus-btn',
        targetElementRef = useRef<HTMLButtonElement | null>(null),

        handleInformationClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            event.preventDefault();
            props.onInformationClicked();
        },
        handleMouseOver = () => {
            if (props.onMouseOver) {
                props.onMouseOver(targetElementRef);
            }
        },
        handleMouseOut = () => {
            if (props.onMouseOut) {
                props.onMouseOut();
            }
        };

    return (
        <Fragment>
            <button
                className={`${containerClassName}`}
                onClick={handleInformationClick}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                tabIndex={props.tabIndex}
                data-tooltip-content={props.tooltip}
                data-tooltip-id={props.dataFor || undefined}
                data-tooltip-delay-show={1500}
                data-tooltip-hide={100}                 
                data-tooltip-place='bottom'
                ref={targetElementRef}
            >
                {props.icon === 'pdf' &&
                    <FileIcon width={props.width || 12} height={props.height || 12} />
                }
                {props.icon === 'info' &&
                    <InformationIcon width={props.width || 6} height={props.height || 12} />
                }
                {props.icon === 'circle' &&
                    <InformationCircleIcon width={props.width || 16} height={props.height || 16} />
                }
                {props.icon === 'idea' &&
                    <IdeaIcon width={props.width || 16} height={props.height || 16} />
                }
            </button>
        </Fragment>
    );
}